import { Component, OnInit } from '@angular/core';
import Utils from '@app/shared/utils/utils';
import { DialogNewDealerComponent } from '../../components/dialog-new-dealer/dialog-new-dealer.component';
import { MatDialog } from '@angular/material/dialog';
import { LmrServices } from '../../services/lmr.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-dealers',
  templateUrl: './dealers.component.html',
  styleUrls: ['./dealers.component.sass'],
})
export class DealersComponent implements OnInit {
  formatCnpj: any = Utils.formatCnpj;
  formatPhone: any = Utils.formatPhone;
  formatIE: any = Utils.formatIE;

  searchTerm: string = '';
  dealers: any[] = [];
  loaded = false;
  totalCount: number = 0;
  page: number = 1;
  pageSize: number = 10;

  constructor(
    private dialog: MatDialog,
    private lmrServices: LmrServices,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadDealers();
  }

  private sanitizeFiltro(term: string): string {
    const stripped = term.replace(/[.\-/]/g, '');
    return /^\d+$/.test(stripped) ? stripped : term;
  }

  loadDealers(): void {
    this.lmrServices
      .getDealers({
        Filtro: this.sanitizeFiltro(this.searchTerm),
        Page: this.page,
        PageSize: this.pageSize,
      })
      .subscribe({
        next: (response) => {
          this.dealers = response?.page;
          this.totalCount = response?.count ?? 0;
          this.loaded = true;
        },
        error: (error) => {
          const msg = error?.errors?.[0] ?? 'Erro ao carregar fornecedores.';
          this.toastr.error(msg);
          this.loaded = true;
        },
      });
  }

  onSearchChange(value: string): void {
    if (value === '') {
      this.onSearch();
    }
  }

  onSearch(): void {
    this.page = 1;
    this.loadDealers();
  }

  onPageChange(event: { pageIndex: number; pageSize: number }): void {
    this.page = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.loadDealers();
  }

  openNewDealerDialog(): void {
    const dialogRef = this.dialog.open(DialogNewDealerComponent, {
      width: '660px',
      maxHeight: '90vh',
      panelClass: 'custom-mat-dialog',
      data: null,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.loadDealers();
      }
    });
  }

  openEditDealerDialog(dealer: any): void {
    const dialogRef = this.dialog.open(DialogNewDealerComponent, {
      width: '660px',
      maxHeight: '90vh',
      panelClass: 'custom-mat-dialog',
      data: dealer,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.loadDealers();
      }
    });
  }

  formatAddress(dealer: any): string {
    const street = [dealer.logradouro, dealer.numero].filter(Boolean).join(', ');
    const streetFull = dealer.complemento ? `${street} - ${dealer.complemento}` : street;
    const cityState = [dealer.bairro, dealer.municipio].filter(Boolean).join(', ');
    const cityStateFull = dealer.uf ? `${cityState} - ${dealer.uf}` : cityState;
    const cep = dealer.cep ? dealer.cep.replace(/^(\d{5})(\d{3})$/, '$1-$2') : '';
    return (
      [streetFull, cityStateFull, cep ? `CEP: ${cep}` : null].filter(Boolean).join(', ') || '-'
    );
  }
}
